import React from 'react';
import Weather from './weather';

const App = () => {
  return (
    <div className="App">
      <Weather />
    </div>
  );
};

export default App;
